import { expectRecord, expectString } from "./schema";
export function parseTenantContext(value, path = "tenant") {
    const record = expectRecord(value, path);
    return {
        tenantId: expectString(record.tenantId, `${path}.tenantId`),
        tenantSlug: expectString(record.tenantSlug, `${path}.tenantSlug`),
        displayName: expectString(record.displayName, `${path}.displayName`)
    };
}
